import React, { useEffect, useState } from 'react';

import { Initiation } from './components/Initiation';
import { Tutorial } from './components/Tutorial';

const CU04801Page = () => {
    const [count, setCount] = useState<number>(1);

    useEffect(() => {
        const timer1 = setTimeout(() => {
            setCount(2);
        }, 3000);
        return () => clearTimeout(timer1);
    }, []);

    const render = (count: number) => {
        switch (count) {
            case 1:
                return <Initiation />;
            case 2:
                return <Tutorial />;
            default:
                return <></>;
        }
    };

    return render(count);
};
export default CU04801Page;
